import React from 'react';
import PropTypes from 'prop-types';
//import Link from 'valuelink'
//import FormInput from '../../../Global/FormInput.js'

class PasajeroFormulario extends React.Component {
    constructor(props) {
        super(props)
        //FC: use este estado para validar los campos en los inputs, en cambio los datos del pasajero en si se guardan en App.js
        this.state = {nombre: '', apellido: '', documento:'', telefono:'', fechaNacimiento: '', sexo: 'M'};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleTipoDocumentoChange = this.handleTipoDocumentoChange.bind(this);
        this.handleNacionalidadChange = this.handleNacionalidadChange.bind(this);
    }


    handleInputChange(e) {
      if (e.target.name === 'telefono') {
        e.target.value = e.target.value.replaceAll('-', '')
      }
      this.props.onPasajeroChange(this.props.numero, e.target.name, e.target.value);
      this.setState({[e.target.name]: e.target.value});

    }

    handleTipoDocumentoChange(e) {
      //  this.props.onPasajeroChange(this.props.numero, e.target.name, this.props.tiposDeDocumento[e.target.value]);
      let idTipoDocumento = e.target.value;
      this.props.onPasajeroChange(this.props.numero, e.target.name, this.props.tiposDeDocumento.find((e) => e.idTipoDocumento === idTipoDocumento));
    }


    handleNacionalidadChange(e) {
        //this.props.onPasajeroChange(this.props.numero, e.target.name, this.props.nacionalidades[e.target.value]);
        let idNacionalidad = e.target.value;
        this.props.onPasajeroChange(this.props.numero, e.target.name, this.props.nacionalidades.find((e) => e.id === idNacionalidad));
    }

    traerTipoDoc() {
        if (this.props.pasajero.tipoDocumento)
              return this.props.pasajero.tipoDocumento.idTipoDocumento;
    }

    traerNacionalidadElegida() {
        if (this.props.pasajero.nacionalidad)
              return this.props.pasajero.nacionalidad.id;
    }

    handleSubmit = (evt) => {
      if (this.props.busqueda.destino === '') {
          this.setState({error: true});
          evt.preventDefault();
          return;
      }
    }

    render() {

      const tiposDeDocumento = this.props.tiposDeDocumento;
      const nacionalidades = this.props.nacionalidades;

        return (
              <form action="#" method="post" className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 datos-personales clearfix">
                <div className="fieldset row bg">
                  <Titulo pasajero={this.props.pasajero} numero={this.props.numero} />
                  {/*<input type="text" name="nombre" placeholder="Nombre" onChange={this.handleInputChange} />*/}
                  <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <label htmlFor="nombre">Nombres
                      <sup>*</sup>
                    </label>
                    <input className={!this.state.nombre ? 'error' : ''} type="text" name="nombre" onChange={this.handleInputChange} placeholder="Nombre completo como figura en el DNI" />
                  </div>
                  {/*<FormInput label="Nombre:" name="nombre" placeholder="Nombre" valueLink={nombreLink} type="text" onChange={this.handleInputChange} />
                  <input type="text" name="apellido" placeholder="Apellido" onChange={this.handleInputChange} />*/}
                  <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <label htmlFor="apellido">Apellido
                      <sup>*</sup>
                    </label>
                    <input className={!this.state.apellido ? 'error' : ''} type="text" name="apellido" onChange={this.handleInputChange} placeholder="Apellido completo como figura en el DNI" />
                  </div>
                {/*  <FormInput label="Apellido:" name="apellido" placeholder="Apellido" valueLink={apellidoLink} type="text" onChange={this.handleInputChange} /> */}
                <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
                    <label className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Tipo y n&uacute;mero de documento
                      <sup>*</sup>
                    </label>
                    <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 select-container">
                      <select name="tipoDocumento" value={this.traerTipoDoc()} onChange={this.handleTipoDocumentoChange}>
                        {
                          tiposDeDocumento.map((tipoDeDocumento) => {
                            return <option key={tipoDeDocumento.idTipoDocumento} value={tipoDeDocumento.idTipoDocumento}>{tipoDeDocumento.sigla}</option>
                          })
                        }
                      </select>
                    </div>
                    <input className={!this.state.documento ? 'col-xl-8 col-lg-8 col-md-5 col-sm-6 col-6 error' : 'col-xl-8 col-lg-8 col-md-5 col-sm-6 col-6'}
                          type="number" onChange={this.handleInputChange} style={{marginLeft: '8%'}}
                           name="documento"placeholder="N&uacute;mero de documento" />
                </div>

                {/*  <select name="tipoDocumento" value={this.traerTipoDoc()} onChange={this.handleTipoDocumentoChange}>
                    {
                      tiposDeDocumento.map((tipoDeDocumento, indice) => {
                        return <option key={tipoDeDocumento.idTipoDocumento} value={tipoDeDocumento.idTipoDocumento}>{tipoDeDocumento.sigla}</option>
                      })
                    }
                  </select>
                  <FormInput label="Documento:" name="documento" placeholder="N° Documento" valueLink={documentoLink} type="text" onChange={this.handleInputChange} />
                  <input type="text" name="documento" placeholder="Numero Documento" onChange={this.handleInputChange} />*/}
                  <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
                    <label htmlFor="fechaNacimiento">Fecha Nacimiento
                      <sup>*</sup>
                    </label>
                    <input className={!this.state.fechaNacimiento ? 'error' : ''} type="date" name="fechaNacimiento" placeholder="Fecha Nacimiento" onChange={this.handleInputChange} />
                  </div>

                  <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 row">
                      <label className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Sexo y Telefono
                        <sup>*</sup>
                      </label>
                      <div className="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 select-container">
                        <select value={this.state.sexo} name="sexo" onChange={this.handleInputChange}>
                            <option value="M">Masculino</option>
                            <option value="F">Femenino</option>
                        </select>
                      </div>
                      <input className={!this.state.telefono ? 'col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6 error' : 'col-xl-8 col-lg-8 col-md-6 col-sm-6 col-6'}
                              type="number" name="telefono" onChange={this.handleInputChange} style={{marginLeft: '8%'}}
                              placeholder="Telefono (sin guiones)" />
                  </div>


                  {/*<FormInput label="Telefono:" name="telefono" placeholder="Telefono" valueLink={telefonoLink} type="text" onChange={this.handleInputChange} />
                <input type="text" name="telefono" placeholder="Telefono" onChange={this.handleInputChange} />
                  <select value="" name="sexo" onChange={this.handleInputChange}>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                  </select>*/}
                  <div className="input-container col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <label htmlFor="nacionalidad">Nacionalidad
                      <sup>*</sup>
                    </label>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 select-container">
                      <select value={this.traerNacionalidadElegida()} name="nacionalidad" onChange={this.handleNacionalidadChange}>
                        {
                          nacionalidades.map((nacionalidad) => {
                            return <option key={nacionalidad.id} value={nacionalidad.id}>{nacionalidad.denominacion}</option>
                          })
                        }
                      </select>
                    </div>
                  </div>

                  </div>
                </form>
              );
    }
}

export default PasajeroFormulario

function Titulo (props) {
  const pasajero = props.pasajero;
  const numero = props.numero;
  if (pasajero.tipoPasajero === 'Menor')
    return <h5 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Pasajero {pasajero.tipoPasajero } de {pasajero.edad} años </h5>;

  return <h5 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Pasajero {pasajero.tipoPasajero } {numero + 1} </h5>;
}

PasajeroFormulario.propTypes = {
  tiposDeDocumento: PropTypes.array,
  nacionalidades: PropTypes.array,
  pasajero: PropTypes.object,
  numero: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/CargaPasajeros/PasajeroFormulario/index.js